import React from "react";

import { STRINGS } from "../utils/string";

export default function ActionItemClient({ item }) {
  return (
    <>
      <span className="font-bold">{item?.name || item?.onCaseName || STRINGS.NO_CLIENT_NAME}</span>
      <div className="mb-1 truncate text-ellipsis">
        <span className="font-bold">{STRINGS.LAW_FIRM}: </span>
        {item?.lawFirmName ? item?.lawFirmName : STRINGS.NO_LAW_FIRM_NAME}
      </div>
    </>
  );
}
